<template>
  <v-widget title="Lịch sử thay đổi">
    <template v-slot:widget-content>
      <v-data-table
        :headers="changedHistoryHeader"
        :items="order.ChangedHistories"
        :mobile-breakpoint="100"
        :footer-props="{ 'items-per-page-options': [10, 20, 30, 40, 50] }"
        :items-per-page="10"
        class="border"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.CreatedDate | display_date }}</td>
            <td class="font-weight-bold">{{ item.Username }}</td>
            <td>{{ item.HistoryContent }}</td>
          </tr>
        </template>
      </v-data-table>
    </template>
  </v-widget>
</template>

<script>
import VWidget from "@/components/VWidget";

export default {
  name: "TabChangeHistory",
  components: {
    VWidget
  },
  props: {
    order: {
      type: Object,
      required: true
    },
    changedHistoryHeader: {
      type: Array,
      required: true
    }
  }
};
</script>
